'use strict';
export const version = "1.0.7";
export const apiurl = 'https://api.zoom.cab/';
export const slaveurl = 'https://api.zoom.cab/';
export const configurl = 'https://api.zoom.cab/customer/app/';
export const dispatchurl = 'https://api.zoom.cab/dispatcher/';
export const pickupicn = './assets/img/pickup.png';
export const dropupicn = './assets/img/drop.png';
export const specialicn = './assets/img/special.png';
export const vehicleicn = './assets/img/vehicle.png';
export const pathicn = './assets/img/driver_accept.png';
export const currenticn = './assets/img/current_location.png';
export const awsid = "AKIAI3QGDBBEE3XMT2PQ";
export const awskey = "F18q+7N/YyHjhMU+VPR+K9Xur4UXqN5jl6DHYYPT";
export const awsbucket = "zoomzoomimages";
export const lang = "0";
export const start_icn = './assets/img/booking_started_flag.png';
export const arrived_icn = './assets/img/arrived_flag.png';
export const reached_icn = './assets/img/reached_destination_flag.png';
export const completed_icn = './assets/img/completed_flat.png';
export const terms_conditin = 'https://superadmin.zoom.cab/supportText/customer/en_termsAndConditions.php';
export const privacy_policy = 'https://superadmin.zoom.cab/supportText/customer/en_privacyPolicy.php';
export const mqtt_channel = 'wss://mqtt.zoom.cab:2083/mqtt';
export const mqtt_username = 'zoomzoom';
export const mqtt_password = 'LVKEsvFkB8qLucI5';
export var pubkeys: any;
export const invoice_admin = 'http://18.224.119.216/api/emailInvoices';
export const websitelink = '#';
export const fblink = 'https://www.facebook.com/';
export const twitterlink = 'https://twitter.com/';
export const linkedinlink = 'https://in.linkedin.com/';
export const linkName = 'customer.biguride.com';
export const year = '2019';
export const uberforalllink = 'customer.zoom.cab';
export const homePageImage  = "header_logo.png";
export const loginPageLogo  = "Zoom 150x53.png";
export const footerLogo  = "zoom_footer_logo.png";



// WEBPACK FOOTER //
// F:/Karry/Zoom/ZoomCustomer/src/app/globals.ts